import { render } from "./Loader.vue?vue&type=template&id=44e7c4f8&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=44e7c4f8&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e7c4f8"]])

export default __exports__